import React from "react";
import SEO from "../components/SEO";
import "./Home.css";

function About() {
  return (
    <>
      <SEO 
        title="About Us - Trivana Hospitality"
        description="Learn about Trivana Hospitality - India's leading hotel and restaurant management software company. Our mission is to revolutionize the hospitality industry through innovative technology solutions."
        keywords="about trivana, hotel management company, restaurant software company, hospitality technology, trivana team, our mission, our vision"
        url="/about"
      />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        {/* Decorative Header */}
        <div className="flex flex-col items-center mb-16 animate-fade-in-up">
          <div className="inline-block px-6 py-2 bg-gradient-to-r from-[#4299f5]/20 to-[#2d7dd1]/20 text-[#4299f5] rounded-full font-semibold text-sm mb-6 border border-[#4299f5]/30">
            Trusted by 500+ Hospitality Businesses
          </div>
          <h1 className="text-5xl font-extrabold text-white sm:text-6xl mb-6" style={{fontFamily: 'Montserrat, sans-serif'}}>
            About <span className="text-[#4299f5]">Trivana Hospitality</span> LLP
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            Empowering hospitality businesses with smart, scalable, and
            beautiful digital solutions.
          </p>
        </div>
        <div className="flex justify-center mb-12 gap-3 flex-wrap">
          <span className="inline-block px-4 py-2 bg-blue-500/10 text-blue-300 rounded-full font-semibold shadow text-sm border border-blue-500/30">
            Hotels
          </span>
          <span className="inline-block px-4 py-2 bg-blue-500/10 text-blue-300 rounded-full font-semibold shadow text-sm border border-blue-500/30">
            Restaurants
          </span>
          <span className="inline-block px-4 py-2 bg-blue-500/10 text-blue-300 rounded-full font-semibold shadow text-sm border border-blue-500/30">
            Cafes & Resorts
          </span>
        </div>
        <p className="text-xl text-white/90 leading-relaxed mb-12 max-w-4xl mx-auto font-normal">
          <span className="font-bold text-[#4299f5]">
            Trivana Hospitality LLP
          </span>{" "}
          is a forward-thinking technology partner for the hospitality industry.
          We offer robust, customizable, and scalable digital management
          solutions tailored for hotels, restaurants, cafes, and resorts. From
          streamlining operations to boosting guest satisfaction, we empower
          hospitality businesses to thrive in a competitive digital-first world.
        </p>
      </div>
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-40 h-40 bg-[#4299f5]/20 rounded-full blur-3xl animate-blob"></div>
      <div className="absolute bottom-20 right-10 w-60 h-60 bg-[#4299f5]/20 rounded-full blur-3xl animate-blob animation-delay-2000"></div>
      </section>

      {/* Content Section */}
      <div className="bg-gray-50 py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Vision and Mission */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 animate-fade-in-up delay-200">
          <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl border-2 border-transparent hover:border-[#4299f5] transform hover:-translate-y-1 transition-all duration-300 flex flex-col items-center">
            <div className="flex items-center mb-3">
              <span className="inline-block w-10 h-10 rounded-full bg-gradient-to-br from-[#4299f5] to-[#2d7dd1] flex items-center justify-center mr-3 shadow-lg">
                <svg
                  className="w-6 h-6 text-white"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm1 17.93V20a1 1 0 0 1-2 0v-.07A8 8 0 1 1 20 12a8 8 0 0 1-7 7.93Z" />
                </svg>
              </span>
              <h3 className="text-xl font-bold text-gray-900" style={{fontFamily: 'Montserrat, sans-serif'}}>
                Our Vision
              </h3>
            </div>
            <p className="text-gray-600 text-base leading-relaxed text-center">
              To be the leading provider of smart and innovative digital
              solutions that redefine hospitality operations and deliver
              unforgettable guest experiences across India and beyond.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl border-2 border-transparent hover:border-[#4299f5] transform hover:-translate-y-1 transition-all duration-300 flex flex-col items-center">
            <div className="flex items-center mb-3">
              <span className="inline-block w-10 h-10 rounded-full bg-gradient-to-br from-[#4299f5] to-[#2d7dd1] flex items-center justify-center mr-3 shadow-lg">
                <svg
                  className="w-6 h-6 text-white"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm1 17.93V20a1 1 0 0 1-2 0v-.07A8 8 0 1 1 20 12a8 8 0 0 1-7 7.93Z" />
                </svg>
              </span>
              <h3 className="text-xl font-bold text-gray-900" style={{fontFamily: 'Montserrat, sans-serif'}}>
                Our Mission
              </h3>
            </div>
            <p className="text-gray-600 text-base leading-relaxed text-center">
              To equip hospitality businesses with affordable, easy-to-use, and
              high-performing software tools for reservations, billing
              (including pakka & kaccha bills), inventory, staff, and customer
              relationship management—all under one roof.
            </p>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="text-center animate-fade-in-up delay-300">
          <h3 className="text-4xl font-bold text-gray-900 mb-12" style={{fontFamily: 'Montserrat, sans-serif'}}>
            Why Choose <span className="text-[#4299f5]">Trivana</span>?
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl border-2 border-transparent hover:border-[#4299f5] transform hover:-translate-y-1 transition-all duration-300 flex flex-col items-center">
              <span className="inline-block w-16 h-16 rounded-full bg-gradient-to-br from-[#4299f5] to-[#2d7dd1] flex items-center justify-center mb-4 shadow-lg">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM14 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4zM14 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z" />
                </svg>
              </span>
              <h4 className="text-lg font-semibold text-gray-900 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                All-in-One Platform
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed text-center">
                Manage bookings, menus, inventory, billing, and staff in one
                seamless system.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl border-2 border-transparent hover:border-[#4299f5] transform hover:-translate-y-1 transition-all duration-300 flex flex-col items-center">
              <span className="inline-block w-16 h-16 rounded-full bg-gradient-to-br from-[#4299f5] to-[#2d7dd1] flex items-center justify-center mb-4 shadow-lg">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </span>
              <h4 className="text-lg font-semibold text-gray-900 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                Tailored for India
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed text-center">
                Includes support for both <strong>Pakka</strong> and{" "}
                <strong>Kaccha</strong> bills, regional tax settings, and
                Hindi/English interfaces.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl border-2 border-transparent hover:border-[#4299f5] transform hover:-translate-y-1 transition-all duration-300 flex flex-col items-center">
              <span className="inline-block w-16 h-16 rounded-full bg-gradient-to-br from-[#4299f5] to-[#2d7dd1] flex items-center justify-center mb-4 shadow-lg">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </span>
              <h4 className="text-lg font-semibold text-gray-900 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                Fast Setup & Support
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed text-center">
                Get started in minutes with our free trial, and access friendly
                support whenever you need it.
              </p>
            </div>
          </div>
        </div>
        
        {/* Decorative Quote */}
        <div className="mt-12 text-center">
          <blockquote className="text-xl italic text-gray-700 font-semibold" style={{fontFamily: 'Montserrat, sans-serif'}}>
            "Redefining hospitality, one experience at a time."
          </blockquote>
        </div>
      </div>
      </div>
    </>
  );
}

export default About;
